import { Constants } from '@leverege/molten-core';
import MapBoxSymbolCreator from "./MapBoxSymbolCreator.js";
import MapBoxRendererCreator from "./MapBoxRendererCreator.js";
import MapboxHistoryRendererCreator from "./MapboxHistoryRendererCreator.js";
import UserPositionRenderer from "./UserPositionRenderer.js";
import UserPositionSymbol from "./UserPositionSymbol.js";
import CenterOnUserAction from "./CenterOnUserAction.js";
import CenterOnItemsAction from "./CenterOnItemsAction.js";
import GroupingsRendererCreator from "./GroupingsRendererCreator.js";
import CenterOnAddressAction from "./CenterOnAddressAction.js";
import ItemTileModel from "./ItemTileModel.js";
import ItemTileRendererCreator from "./ItemTileRendererCreator.js";
import ItemTileEditor from "./ItemTileEditor.js";
const install = molten => {
  molten.addPlugin(Constants.BLUEPRINT_RELATIONSHIP_PROCESSOR, MapBoxSymbolCreator);
  molten.addPlugin(Constants.BLUEPRINT_RELATIONSHIP_PROCESSOR, MapBoxRendererCreator);
  molten.addPlugin(Constants.BLUEPRINT_RELATIONSHIP_PROCESSOR, MapboxHistoryRendererCreator);
  molten.addPlugin('MapBoxRenderer', UserPositionRenderer);
  molten.addPlugin('MapSymbol', UserPositionSymbol);
  molten.addPlugin(Constants.BLUEPRINT_RELATIONSHIP_PROCESSOR, GroupingsRendererCreator);
  molten.addPlugin('Action', CenterOnAddressAction);
  molten.addPlugin('Action', CenterOnUserAction);
  molten.addPlugin('Action', CenterOnItemsAction);
  molten.addPlugin('Model', {
    type: ItemTileModel.TYPE,
    model: ItemTileModel
  });
  // molten.addPlugin( 'ModelEditor', { type : Model.TYPE, editor : GeoLayerEditor } )
  molten.addPlugin('ModelEditor', {
    type: ItemTileModel.TYPE,
    editor: ItemTileEditor
  });
  molten.addPlugin('Molten.blueprintRelationshipProcessor', ItemTileRendererCreator);
};
export default {
  install
};